<template>
  <section>
    <el-collapse v-model="isOpen">
      <el-collapse-item
        :title="$t('common.search')"
        name="blocked-accounts-search-section"
        id="blocked-accounts-search-section"
      >
        <el-form
          id="blocked-accounts-search-section-form"
          class="search-section-form"
          :model="searchFormModel"
          ref="searchForm"
          label-position="right"
          size="mini"
          inline
        >
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item :label="$t('blockedAccounts.dateFrom')">
                <el-date-picker
                  class="el-dropdown-new drop-sp date-dob"
                  v-model="searchFormModel.startDate"
                  format="MM/dd/yyyy"
                  type="date"
                  @change="handleChangeStartDate"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('blockedAccounts.dateTo')">
                <el-date-picker
                  class="el-dropdown-new drop-sp date-dob"
                  v-model="searchFormModel.endDate"
                  format="MM/dd/yyyy"
                  clearable
                  type="date"
                  @change="handleChangeEndDate"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8" class="text-align-end">
              <el-form-item
                  :label="$t('blockedAccounts.status')"
                  prop="status"
                  class="title-input">
                <el-select
                  v-model="searchFormModel.status"
                  id="searchForm-status"
                  ref="filter-status"
                  @change="handleSearch"
                >
                  <el-option
                      v-for="item in blockedAccountStatusOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item :label="$t('blockedAccounts.warehouse')">
                <outbound-warehouse-select
                  v-model="searchFormModel.warehouseId"
                  @change="handleSearch"
                  :includeOptionAll="true"
                ></outbound-warehouse-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$t('blockedAccounts.shippers')"
              >
                <autocomplete
                  :model.sync="searchFormModel.shipperAccountId"
                  :url="urlShipperAutocomplete"
                  labelField="name"
                  labelFieldLastWithDash="number"
                  :selectAction="handleSearch"
                  :enterKeyAction="handleSearch"
                  :clearAction="handleSearch"
                  :classCss="null"
                  valueField="id"
                ></autocomplete>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('blockedAccounts.consignee')">
                <autocomplete
                  :model.sync="searchFormModel.consigneeAccountId"
                  :shipperAccountId="null"
                  labelFieldLastWithDash="number"
                  :url="urlConsigneeAutocomplete"
                  :selectAction="handleSearch"
                  :enterKeyAction="handleSearch"
                  :clearAction="handleSearch"
                  labelField="name"
                  valueField="id"
                ></autocomplete>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10">
            <el-col :span="24" class="text-align-end">
              <el-tooltip
                :content="$t('common.search')"
                class="item"
                effect="dark"
                placement="top-start"
              >
                <el-button
                  id="blocked-accounts-search-section-form-button"
                  class="button-action-default"
                  @click="handleSearch"
                  icon="el-icon-search"
                  size="mini"
                ></el-button>
              </el-tooltip>
            </el-col>
          </el-row>
        </el-form>
      </el-collapse-item>
    </el-collapse>
  </section>
</template>

<script>
import moment from 'moment';
import { mapActions } from 'vuex';
import { BLOCKED_ACCOUNTS_SEARCH } from '@/store/actions';
import constants from '@/utils/constants';
import apiConstants from '@/utils/apiConstants';
import Autocomplete from '@/components/Autocomplete';
import OutboundWarehouseSelect from '@/views/routing/components/OutboundWarehouseSelect';

export default {
  name: 'BlockedAccountsSearchSection',
  components: {
    Autocomplete,
    OutboundWarehouseSelect
  },
  computed: {
    blockedAccountStatusOptions: () => constants.BLOCKED_ACCOUNTS.STATUS,
    urlShipperAutocomplete: () => apiConstants.END_POINTS.ACCOUNTS.SHIPPERS,
    urlConsigneeAutocomplete: () => apiConstants.END_POINTS.ACCOUNTS.CONSIGNEE,
  },
  data() {
    return {
      activeCollapsibleName: ['blocked-accounts-search-section'],
      isOpen: ['blocked-accounts-search-section'],
      searchFormModel: {
        warehouseId: null,
        shipperAccountId: null,
        consigneeAccountId: null,
        startDate: new Date(),
        endDate: new Date(),
        status: constants.BLOCKED_ACCOUNTS.STATUS[1].value // Active
      }
    };
  },
  mounted() {
    this.handleSearch();
  },
  methods: {
    ...mapActions({
      search: BLOCKED_ACCOUNTS_SEARCH,
    }),
    handleSearch() {
      this.search(this.searchFormModel);
    },
    handleChangeStartDate() {
      if (this.searchFormModel.endDate
          && moment(this.searchFormModel.startDate.getTime()).isAfter(moment(this.searchFormModel.endDate.getTime()))) {
        this.searchFormModel.endDate = this.searchFormModel.startDate;
      }
      this.handleSearch();
    },
    handleChangeEndDate() {
      if (this.searchFormModel.endDate
          && moment(this.searchFormModel.endDate.getTime()).isBefore(moment(this.searchFormModel.startDate.getTime()))) {
        this.searchFormModel.startDate = this.searchFormModel.endDate;
      }
      this.handleSearch();
    }
  }
};
</script>
